import React from "react";

const IconBook = ({ color = "#e31c19" }) => {
  return (
    <svg
      id="UI_icon_book_light"
      data-name="UI icon/book/light"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Union"
        d="M10,16.946a1,1,0,0,1-.316-.051l-1.76-.587A5.981,5.981,0,0,0,6.026,16H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H7a4,4,0,0,1,3,1.355A4,4,0,0,1,13,0h4a3,3,0,0,1,3,3V13a3,3,0,0,1-3,3H13.973a5.981,5.981,0,0,0-1.9.308l-1.76.587A1,1,0,0,1,10,16.946ZM13,2a2,2,0,0,0-2,2V14.558l.444-.148a7.994,7.994,0,0,1,2.53-.41H17a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1ZM3,2A1,1,0,0,0,2,3V13a1,1,0,0,0,1,1H6.026a7.994,7.994,0,0,1,2.53.41L9,14.558V4A2,2,0,0,0,7,2Z"
        transform="translate(2 4)"
        fill={color}
      />
    </svg>
  );
};

export default IconBook;
